import { createSelector } from 'reselect'

export const getActivityState = (state) => state.mars.activity

export const getDisputesActivity = createSelector([getActivityState], (activities) =>
  activities.data.filter((activity) => activity.type === 'DISPUTE_RESOLVED')
)

export const getDebatesActivity = createSelector([getActivityState], (activities) =>
  activities.data.filter((activity) => activity.type === 'DEBATE_RESOLVED')
)

export const getMISActivity = createSelector([getActivityState], (activities) =>
  activities.otherPlayersData.filter(
    (activity) =>
      activity.type === 'BATTLE_WON' ||
      activity.type === 'BATTLE_LOST' ||
      activity.type === 'LEADER' ||
      activity.type === 'FEDERATION_PUNISHMENT' ||
      activity.type === 'FEDERATION_REWARD' ||
      activity.type === 'RRHH_MESSAGE'
  )
)

export const getBattlesActivity = createSelector([getActivityState], (activities) =>
  activities.data.filter(
    (activity) => activity.type === 'BATTLE_WON' || activity.type === 'BATTLE_LOST'
  )
)
export const getOthersBattlesActivity = createSelector([getActivityState], (activities) =>
  activities.visitingPlayer.filter(
    (activity) => activity.type === 'BATTLE_WON' || activity.type === 'BATTLE_LOST'
  )
)

export const getDisputesInfo = createSelector([getDisputesActivity], (disputesActivity) =>
  disputesActivity.map((activity) => activity.data)
)

export const getDebatesInfo = createSelector([getDebatesActivity], (debatesActivity) =>
  debatesActivity.map((activity) => activity.data)
)

export const getMISInfo = createSelector([getMISActivity], (MISActivity) =>
  MISActivity.map((activity) => Object.assign({}, activity.data, { type: activity.type }))
)

export const getBattlesInfo = createSelector([getBattlesActivity], (battlesActivity) =>
  battlesActivity.map((activity) => Object.assign({}, activity.data, { type: activity.type }))
)
